import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { Spinner } from 'components';
import { useWindowSize } from 'hooks';
import { Equipment, EquipmentCategory, EquipmentsTableFields } from 'types/equipments';

import { DEFAULT_EQUIPMENTS_FIELDS, MOBILE_EQUIPMENTS_FIELDS } from '../config';
import { initialWindowSizeProps } from '../constants';
import { EmptyState } from '../EmptyState';
import { OnRegisteredClickT } from '../RegisteredEquipmentsContainer/types';
import { ContainerW, TitleW } from '../styled';
import { Table } from '../Table';
import { useRequestedEquipmentTable } from './hooks/useRequestedEquipmentTable';

interface RequestedEquipmentsContainerProps {
  isSwedish: boolean;
  onTrashIconClick: (equipment: Pick<Equipment, 'id' | 'name'>) => void;
  category: EquipmentCategory | null;
}

export function RequestedEquipmentsContainer({
  isSwedish,
  onTrashIconClick,
  category,
}: RequestedEquipmentsContainerProps): ReactElement {
  const { employeeId = '' } = useParams<string>();
  const { isLoading, equipmentList, handleViewEquipment } = useRequestedEquipmentTable({
    category,
    userId: employeeId,
    onTrashIconClick,
    isSwedish,
  });
  const { isMobile } = useWindowSize(initialWindowSizeProps);
  const { t } = useTranslation();

  const webColumns = DEFAULT_EQUIPMENTS_FIELDS;
  const mobileColumns = MOBILE_EQUIPMENTS_FIELDS;

  return (
    <>
      <ContainerW isListData={!!equipmentList.length}>
        <TitleW>{t('equipments.request.title')}</TitleW>

        {isLoading && <Spinner />}

        {!isLoading && !equipmentList.length && <EmptyState isRequestedState />}

        {!isLoading && !!equipmentList.length && (
          <Table<EquipmentsTableFields, OnRegisteredClickT>
            isLoading={isLoading}
            columns={isMobile ? mobileColumns : webColumns}
            data={equipmentList}
            onClickRow={handleViewEquipment}
          />
        )}
      </ContainerW>
    </>
  );
}
